import { createAsyncThunk } from "@reduxjs/toolkit";
// urls
import * as URLS from "../../urls";
//axios
import axios from "../../utilies/axios";
//_________________________________________________

// GET =>  All ALL USERS SERVICE
export const getUsersService = createAsyncThunk(
  "users/getUsersService",
  async (params, thunkAPI) => {
    try {
      const response = await axios.get(URLS.usersURL, {
        params: { ...params },
      });
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

// POST =>  CREATE USER SERVICE
export const createUserService = createAsyncThunk(
  "users/createUserService",
  async (data, thunkAPI) => {
    try {
      const response = await axios.post(URLS.usersURL, data);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

// DELETE =>  DELETE USER SERVICE
export const deleteClientService = createAsyncThunk(
  "users/deleteUserService",
  async (id, thunkAPI) => {
    try {
      const response = await axios.delete(`${URLS.usersURL}/${id}`);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

// UPDATE =>  UPDATE USER SERVICE
export const updateUserService = createAsyncThunk(
  "users/updateUserService",
  async (params, thunkAPI) => {
    try {
      const response = await axios.put(`${URLS.usersURL}/${params?.id}`,params?.data);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);
